import React, { useEffect, useMemo, useState } from "react";
import BreadCrumbsGeneric from "../../components/Nav/BreadCrumbsGeneric";
import { useLocation, useNavigate } from "react-router-dom";
import ConsumoController from "../../controllers/ConsumoController";
import Spinner from "../../components/Loading/loadingSpinner/Spinner";
import {
  ArrowSmUpIcon,
  ArrowLeftIcon,
  ArrowDownIcon,
  ArrowNarrowUpIcon,
} from "@heroicons/react/solid";
import { UseContextApp } from "../../Global/Context/appContext";
import { colors } from "../../propsType/Colors";
function ViewDetails() {
  const navigate = useNavigate();
  //Te indica en que rutas estas actualmente
  const location = useLocation();
  const pathName = location.pathname;
  const [data, setData] = useState("");
  const { estadoCuenta } = ConsumoController();
  const [loading, setLoading] = useState(false);
  const [dataDetails, setDataDetails] = useState("");
  const [{ user }] = UseContextApp();
  const getEstadoCuenta = async () => {
    setLoading(true);
    let newObjet = {
      nroCuenta: data.nroCuenta,
      docIdentidad: user.id,
      docType: user.type,
    };
    if (data) {

      const res = await estadoCuenta(newObjet);

      if (res) {
        setDataDetails(res?.lEdoCuenta);
        setLoading(false);
      }
    }
  };
  const orderDate = () => {
    let res = dataDetails.reverse();

    setDataDetails([...res]);
  };

  useEffect(() => {
    setData(location?.state?.data);
  }, [location]);

  useEffect(() => {
    getEstadoCuenta();

  }, [data]);

  const stats = [
    {
      name: "Número de Cuenta",
      stat: data?.nroCuenta,
      previousStat: "",
      change: "",
      changeType: "",
    },
    {
      name: "Titular",
      stat: user?.datos?.nombreApellido,
      previousStat: "",
      change: "",
      changeType: "",
    },
  ];
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <div className=" bg-[#f3f4f6] ">
      <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
        {loading ? (
          <>
            <div className="w-full h-screen flex justify-center items-center ">
              <Spinner title={"Espere..."} />
            </div>
          </>
        ) : (
          <>
            <div className="flex lg:w-full gap-5 px-4 overflow-auto flex-col">
                {/*   Recibe la navegacion que te indica en que ruta estas */}
              <BreadCrumbsGeneric locations={pathName} />
              <button
                className="bg-white w-[30%] md:w-[10%] h-11 flex justify-center items-center rounded-md shadow px-6  space-x-4"
                onClick={() => navigate(-1)}
              >
                <div className="flex w-full justify-between items-center">
                  <div>
                    <ArrowLeftIcon className="h-5 w-5" />
                  </div>
                  <div>Volver</div>
                </div>
              </button>
              <div>
                <dl className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
                  {stats.map((item) => (
                    <div key={item.name} className="px-4 py-5 sm:p-6">
                      <dt className="text-base font-normal text-gray-900 ">
                        {item.name}
                      </dt>
                      <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
                        <div className="flex items-baseline whitespace-nowrap text-2xl font-semibold text-[#5AB9E5] ">
                          {item.stat}
                          <span className="ml-2 text-sm font-medium text-gray-500">
                            {" "}
                            {item.previousStat}
                          </span>
                        </div>
                        <div
                          className={classNames(
                            item.changeType === "increase" &&
                            "bg-green-100 text-green-800",
                            "inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0"
                          )}
                        >
                          {item.changeType === "increase" && (
                            <ArrowSmUpIcon
                              className="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500"
                              aria-hidden="true"
                            />
                          )}
                          <span className="sr-only">
                            {item.changeType === "increase"
                              ? "Increased"
                              : "Decreased"}{" "}
                            by
                          </span>
                          {item.change}
                        </div>
                      </dd>
                    </div>
                  ))}
                </dl>
              </div>
              <div className="!m-0 !mb-[100px] overflow-x-auto sm:-mx-6 lg:-mx-8 bg-white rounded-[10px] gap-5 shadow-lg  mt-5 ">
                <div className=" py-6 px-6 sm:px-6">
                  <div className="py-2 text-2xl font-medium ">
                    Estado de Cuenta{" "}
                  </div>
                  <div className=" text-lg font-regular ">
                    {" "}
                    Visualiza el estado de cuenta de los últimos 6 meses{" "}
                  </div>
                </div>
                {dataDetails?.length > 0 ? (
                  <>
                    <div className="bg-white shadow overflow-hidden sm:rounded-md">
                      <ul role="list" className="divide-y divide-gray-200">
                        <div className=" hidden px-4 py-2 md:grid gap-4 lg:grid-cols-8 sm:px-6 border-b border-gray-200">
                          <div
                            className={`font-medium text-center flex justify-center gap-3  text-[14px] text-[${colors.darkBlue}]`}
                          >
                            <div>Fecha</div>
                            <div
                              className="flex justify-end items-center cursor-pointer"
                              onClick={() => orderDate()}
                            >
                              <ArrowDownIcon className="h-3 w-3" />
                              <ArrowNarrowUpIcon className="h-3 w-3" />
                            </div>
                          </div>
                          <div
                            className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                          >
                            Tipo de Documento
                          </div>
                          <div
                            className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                          >
                            Código
                          </div>
                          <div
                            className={`font-medium  text-center text-[14px] text-[${colors.darkBlue}]`}
                          >
                            Estatus
                          </div>
                          <div
                            className={`font-medium  text-center text-[14px] text-[${colors.darkBlue}]`}
                          >
                            Abono
                          </div>
                          <div
                            className={`font-medium  text-center text-[14px] text-[${colors.darkBlue}]`}
                          >
                            Cargo
                          </div>
                          <div
                            className={`font-medium  text-center text-[14px] text-[${colors.darkBlue}]`}
                          >
                            Saldo
                          </div>
                          <div
                            className={`font-medium  text-center text-[14px] text-[${colors.darkBlue}]`}
                          >
                            Detalle
                          </div>
                        </div>
                        {dataDetails.map((stateCuenta) => (
                          <li key={stateCuenta.id}>
                            <div className="px-4 py-4 grid gap-4 lg:grid-cols-8 sm:px-6 group-hover:bg-gray-50">
                              <div
                                className={`text-sm text-start justify-center flex items-end font-medium text-[${colors.lightBlue}]  truncate`}
                              >
                                {stateCuenta.fecha}
                              </div>
                              <div>
                                <div className="flex items-center gap-2 flex-col text-sm text-gray-500">
                                  <div className="font-medium text-[14px] md:hidden block  ">
                                    Tipo de Documento
                                  </div>
                                  <div className="flex">
                                    {stateCuenta.descTipoDocumento}
                                  </div>
                                </div>
                              </div>
                              <div className="mt-2 flex gap-2  flex-col items-center text-sm text-gray-500 sm:mt-0 ">
                                <div className="font-medium text-[14px] md:hidden block  ">
                                  Código
                                </div>
                                <div className="flex">{stateCuenta.codigo}</div>
                              </div>
                              <div className="mt-2 flex gap-2 flex-col items-center text-sm text-gray-500 sm:mt-0">
                                <div className="font-medium text-[14px] md:hidden block  ">
                                  Estatus
                                </div>
                                <div className="flex">
                                  <p>{stateCuenta.status}</p>
                                </div>
                              </div>
                              <div className="mt-2 flex gap-2 flex-col items-center text-sm text-gray-500 sm:mt-0">
                                <div className="font-medium text-[14px] md:hidden block  ">
                                  Abono
                                </div>
                                <div className="flex font-bold bg-gray-100 w-full justify-center items-center rounded-full ">
                                  {stateCuenta.abono === "0" ? (
                                    "-"
                                  ) : (
                                    <p>
                                      {""}
                                      {stateCuenta.abono}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="mt-2 flex gap-2 flex-col items-center text-sm text-gray-500 sm:mt-0">
                                <div className="font-medium text-[14px] md:hidden block  ">
                                  Cargo
                                </div>
                                <div className="flex font-bold bg-gray-100 w-full justify-center items-center rounded-full ">
                                  {stateCuenta.cargo === "0" ? (
                                    "-"
                                  ) : (
                                    <p>
                                      {""}
                                      {stateCuenta.cargo}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="mt-2 flex gap-2 flex-col items-center text-sm text-gray-500 sm:mt-0">
                                <div className="font-medium text-[14px] md:hidden block  ">
                                  Saldo
                                </div>
                                <div className="flex font-bold bg-gray-100 w-full justify-center items-center rounded-full ">
                                  {stateCuenta.saldo === "0" ? (
                                    "-"
                                  ) : (
                                    <p>
                                      {""}
                                      {stateCuenta.saldo}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="flex items-end w-full justify-around ">
                                {stateCuenta.url ? (
                                  <>
                                    <a href={stateCuenta.url} target="_Blank">
                                      <div
                                        className={`font-medium text-[${colors.lightBlue}]`}
                                      >
                                        📥Descargar
                                      </div>
                                    </a>
                                  </>
                                ) : (
                                  <>No Disponible</>
                                )}
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="h-[20vh] flex justify-center items-center text-[1.3rem] font-semibold  ">
                      Estado de cuenta no disponible
                    </div>
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ViewDetails;
